import Vue from 'vue'
import VueRouter from 'vue-router'
import request from '@/utils/request.js';

Vue.use(VueRouter)

const router = new VueRouter({
  // history: createWebHistory("/ScorePeredictor"),
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/zd/dxq',
      name: 'zdDxq',
      component: () => import('@/views/zdyc/Dxq.vue'),
      meta: {
        requiresAuth:true,
        pageTitle: '滚球大小球',
        breadcrumb: [
          {
            text: 'Home',
            active: true,
          },
        ],
      },
    },
    {
      path: '/zd/rq',
      name: 'zdRq',
      component: () => import('@/views/zdyc/Rq.vue'),
      meta: {
        requiresAuth:true,
        pageTitle: '滚球亚让',
        breadcrumb: [
          {
            text: 'Home',
            active: true,
          },
        ],
      },
    },
    {
      path: '/zd/jq',
      name: 'zdJq',
      component: () => import('@/views/zdyc/Jq.vue'),
      meta: {
        requiresAuth:true,
        pageTitle: '滚球角球',
        breadcrumb: [
          {
            text: 'Home',
            active: true,
          },
        ],
      },
    },
    {
      path: '/cp/dxq',
      name: 'cpDxq',
      component: () => import('@/views/cpyc/Dxq.vue'),
      meta: {
        requiresAuth:true,
        pageTitle: '初盘大小球',
        breadcrumb: [
          {
            text: 'Home',
            active: true,
          },
        ],
      },
    },
    {
      path: '/cp/rq',
      name: 'cpRq',
      component: () => import('@/views/cpyc/Rq.vue'),
      meta: {
        requiresAuth:true,
        pageTitle: '初盘亚让',
        breadcrumb: [
          {
            text: 'Home',
            active: true,
          },
        ],
      },
    },
    {
      path: '/cp/jq',
      name: 'cpJq',
      component: () => import('@/views/cpyc/Jq.vue'),
      meta: {
        requiresAuth:true,
        pageTitle: '初盘角球',
        breadcrumb: [
          {
            text: 'Home',
            active: true,
          },
        ],
      },
    },
    {
      path: '/Dashboards',
      name: 'Dashboards',
      component: () => import('@/views/Dashboards.vue'),
      meta: {
        requiresAuth:true,
        pageTitle: 'Dashboards',
        breadcrumb: [
          {
            text: 'Dashboards',
            active: true,
          },
        ],
      },
    },
    {
      path: '/second-page',
      name: 'second-page',
      component: () => import('@/views/SecondPage.vue'),
      meta: {
        pageTitle: 'Second Page',
        breadcrumb: [
          {
            text: 'Second Page',
            active: true,
          },
        ],
      },
    },

    {
      path: '/accountSetting',
      name: 'accountSetting',
      component: () => import('@/views/account-setting/UserCenter.vue'),
      meta: {
        requiresAuth:true,
        pageTitle: '个人中心',
        breadcrumb: [
          {
            text: 'Pages',
          },
          {
            text: 'Account Settings',
            active: true,
          },
        ],
      },
    },

    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: {
        pageTitle: '登录',
        layout: 'full',
      },
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('@/views/register/Register.vue'),
      meta: {
        pageTitle: '注册',
        layout: 'full',
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },

    {
      path: '/',
      name: 'homePath',
      component: () => import('@/views/open/Home.vue'),
      meta: {
        pageTitle: '主页',
        layout: 'full',
      },
    },

    {
      path: '/home/RealTimeReports',
      name: 'HRealTimeReports',
      component: () => import('@/views/open/RealTimeReports.vue'),
      meta: {
        pageTitle: '实时战报',
        layout: 'full',
      },
    },
    {
      path: '/home/HistoryReports',
      name: 'HHistoryReports',
      component: () => import('@/views/open/HistoryReports.vue'),
      meta: {
        pageTitle: '历史战报',
        layout: 'full',
      },
    },
    {
      path: '/home/DownLoad',
      name: 'HDownLoad',
      component: () => import('@/views/open/DownLoad.vue'),
      meta: {
        pageTitle: '软件下载',
        layout: 'full',
      },
    },
    {
      path: '/home/MemberBenefits',
      name: 'HMemberBenefits',
      component: () => import('@/views/open/MemberBenefits.vue'),
      meta: {
        pageTitle: '会员权益',
        layout: 'full',
      },
    },
    {
      path: '/home/ContactUs',
      name: 'HContactUs',
      component: () => import('@/views/open/ContactUs.vue'),
      meta: {
        pageTitle: '联系我们',
        layout: 'full',
      },
    },
    

    {
      path: '/home',
      name: 'home',
      component: () => import('@/views/open/Home.vue'),
      meta: {
        pageTitle: '主页',
        layout: 'full',
      },
    },

    {
      path: "/home/:code",
      name: 'homeCode',
      component: () => import('@/views/open/Home.vue'),
      meta: {
        pageTitle: '主页',
        layout: 'full',
      },
    },

    {
      path: '/RealTimeReports',
      name: 'RealTimeReports',
      component: () => import('@/views/open/RealTimeReports.vue'),
      meta: {
        pageTitle: '实时战报',
        layout: 'full',
      },
    },
    {
      path: '/HistoryReports',
      name: 'HistoryReports',
      component: () => import('@/views/open/HistoryReports.vue'),
      meta: {
        pageTitle: '历史战报',
        layout: 'full',
      },
    },
    {
      path: '/DownLoad',
      name: 'DownLoad',
      component: () => import('@/views/open/DownLoad.vue'),
      meta: {
        pageTitle: '软件下载',
        layout: 'full',
      },
    },
    {
      path: '/MemberBenefits',
      name: 'MemberBenefits',
      component: () => import('@/views/open/MemberBenefits.vue'),
      meta: {
        pageTitle: '会员权益',
        layout: 'full',
      },
    },
    {
      path: '/ContactUs',
      name: 'ContactUs',
      component: () => import('@/views/open/ContactUs.vue'),
      meta: {
        pageTitle: '联系我们',
        layout: 'full',
      },
    },


   

  ],
})


router.beforeEach((to, from, next) => {
  let path = to.path;

  // 查找最后一个'/'的索引  
  const lastIndex = path.lastIndexOf('/');

  // 如果存在'/'，则取最后一个'/'之后的所有内容作为参数  
  if (lastIndex !== -1) {
    path = path.substring(lastIndex + 1);
  }

  // 判断是否登录
  const isLogin = localStorage.getItem('footy_token')
  if (to.meta.requiresAuth && !isLogin) {
    next('/login');
    // ElMessage({
    //   message: '请先登录系统',
    //   type: 'warning',
    // })
  } else {
    next();
  }
  if (to.meta.requiresAuth) {
    return;
  }
  var post_url =
    '/AI/count?route=' + to.meta.pageTitle + '_' + path;
  let opts = {
    type: 1, //1为数据接口；2为静态资源请求
    url: post_url,
    method: 'get'
  };
  if (process.env.NODE_ENV === 'production') {
    request.openHttpRequest(opts).then(res => { });
  }

})


// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})



export default router
